import { render, staticRenderFns } from "./Checklist.vue?vue&type=template&id=2775e2c2&"
import script from "./Checklist.vue?vue&type=script&lang=ts&"
export * from "./Checklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports